<script>
    // Import general mixin for shared functionality.
    import mixin from './../mixin';

    import SourceSet from './SourceSet.vue';

    import constants from './../../constants.js';

    export default {
        mixins: [mixin],
        components: { SourceSet },
        data() {
            return {
                constants: constants
            }
        },
        computed: {
            widgetImage() {
                return this.item.image && this.item.image.length ? this.item.image.filter(set => set.alias === 'previewBlockImage_') : null;
            }
        },
        methods: {
            getNumber(string) {
                return string.match(/\d+/g).map(Number)[0];
            }
        },
        props: {
            item: Object
        }
    }
</script>

<template>
    <a :href="item.detailUrl" class="highlight-item is-relative">
        <div class="highlight-item-content" v-if="item.start || item.end || item.title || item.productionType || (item.minimumAge && getNumber(item.minimumAge.name))">
            <time :datetime="item.filterDate" class="is-size-4 has-text-white" v-if="(item.start || item.end) && item.agendaItemType.id !== constants.keys.exhibitionId && item.agendaItemType.id !== constants.keys.activityId">
                {{ toTimeStr(item.start) }}
                <template v-if="item.start && item.end">-</template> {{ toTimeStr(item.end) }}
            </time>
            <h3 class="title is-3 has-text-white" v-if="item.title">{{ item.title }}</h3>
            <div class="highlight-item-info is-flex" v-if="item.productionType || (item.minimumAge && getNumber(item.minimumAge.name))">
                <span class="highlight-item-tag has-background-warning" v-if="item.productionType">{{ item.productionType }}</span>
                <span class="highlight-item-tag has-background-warning" v-if="item.minimumAge && getNumber(item.minimumAge.name)">{{ getNumber(item.minimumAge.name) }} +</span>
            </div>
        </div>
        <template v-if="widgetImage && widgetImage.length">
            <source-set :imageSets="widgetImage" image-class="highlight-item-image"/>
        </template>
        <picture class="highlight-item-image highlight-item-image--fallback" v-else>
            <img src="/svg/one-planet.svg" alt="One Planet" loading="lazy" width="499" height="238">
        </picture>
    </a>
</template>